<div [ngClass]="!desktopScreen ? 'container' : null">
  @if (searchInput) {
    <div nxRow class="pagination-container">
      <div nxCol="6" class="items-per-page">
        <span class="result-label lbl">
          {{ this.count }} results for {{ searchInput }}
        </span>
      </div>
      <div
        nxCol="12,12,6,6"
        class="d-flex justify-content-flex-end"
        [ngClass]="
          desktopScreen
            ? 'd-flex justify-content-flex-end'
            : 'pagination-content'
        "
      >
        <nx-pagination
          next="test"
          class="std-pd-top-10"
          [count]="count"
          [page]="curPageSelected"
          [perPage]="perPageSelected"
          (goPrev)="prevPage()"
          (goNext)="nextPage()"
          (goPage)="goToPage($event)"
        >
        </nx-pagination>
      </div>
    </div>
  }
</div>
